import { jsx as _jsx } from "react/jsx-runtime";
import Snackbar from "../Snackbar/Snackbar";
import useRoomState from "../../hooks/useRoomState/useRoomState";
import { useWrappedTranslation } from "../../utils/i18nService";
export default function ReconnectingNotification() {
    const t = useWrappedTranslation();
    const roomState = useRoomState();
    return (_jsx(Snackbar, { variant: "error", headline: t("ReconnectingNotification.Headline"), message: t("ReconnectingNotification.Message"), open: roomState === "reconnecting" }));
}
